import React, { useEffect } from 'react';

export const NavigateExternal: React.FC<{ to: string }> = (props) => {
  useEffect(() => {
    window.location.href = props.to;
  }, [props.to]);
  return null;
};
